<template>
  <c-select
    v-model="month"
    title="ПЕРИОД:"
    form-group
    form-group-margin-bottom
    :options="monthsFormated"
    :bold="isRangeTypeMonth"
    :label-width="labelWidth"
    :select-width="selectWidth"
  />
</template>

<script>
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'
import { mapGetters, mapActions, mapState } from 'vuex'
import moment from 'moment'
import { getMonthsFormated } from '../../../../../../../resources/js/helper'

/**
 * Select для выбора периода (месяца) отчета.
 */
export default {
  name: 'PeriodRangeMonthSelect',
  components: {
    CSelect
  },
  props: {
    labelWidth: {
      type: String,
      default: null
    },
    selectWidth: {
      type: String,
      default: null
    }
  },
  computed: {
    /**
     * За какой период (месяц) показать отчет.
     */
    month: {
      get () {
        return this.$store.state.seo.positionsFilter.rangeMonth
      },
      set (value) {
        this.changeRangeMonth(value)
      }
    },
    /**
     * Элементы выпадающего списка с выбором периода (месяца).
     *
     * @returns {{}}
     */
    monthsFormated () {
      let dates = {}

      if (this.clientProjectsSelectedProjectId) {
        dates = getMonthsFormated(this.getSelectedProject.work_start_date, moment())
      }

      return dates
    },
    ...mapGetters({
      isRangeTypeMonth: 'seo/positionsFilter/isRangeTypeMonth',
      getSelectedProject: 'seo/client/projects/getSelectedProject'
    }),
    ...mapState({
      clientProjectsSelectedProjectId: state => state.seo.client.projects.selectedProjectId
    })
  },
  methods: {
    ...mapActions({
      changeRangeMonth: 'seo/positionsFilter/changeRangeMonth'
    })
  }
}
</script>
